import React, { useEffect, useState } from "react";
import { ReactComponent as BackIcon } from "../../images/back.svg";
import { Button, DatePicker } from "antd";
import SwitchBox from "../../components/SwitchBox/SwitchBox";
import SearchInput from "../../components/SearchInput/SearchInput";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import PaymentHistoryTable from "./PaymentHistoryTable";
import { PaymentHistoryData } from "./UserData";
import axios from "../../axios/axios";

export const DetailSummaryList = [
  { id: 1, name: "Week" },
  { id: 2, name: "Month" },
  { id: 3, name: "Quarter" },
  { id: 4, name: "Year" },
];

const PaymentHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    pageLimit: 10,
    pageNo: 1,
  });
  const [paymentHistory, setPaymetHistory] = useState([]);

  const GetPaymentHistory = async () => {
    const resp = await axios.get(
      `/bonus/summary/transactions/${pagination?.pageLimit}/${pagination?.pageNo}`
    );
    if (resp.status < 400) {
      setPaymetHistory(resp.data?.data);
    }
  };
  const onPaginationChange = (paginationObj) => {
    console.log("paginationObj", paginationObj);
    setPagination({
      pageNo: paginationObj?.current,
      pageLimit: paginationObj?.pageSize,
    });
  };

  useEffect(() => {
    GetPaymentHistory();
  }, [pagination]);
  console.log("paymentHistory", paymentHistory);

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/bonus-summary/detailsummary", {
                  state: location.state,
                });
              }}
            >
              <BackIcon />
            </span>
            Payment History
          </h1>
          {/* <Button type="button" className="btn-primary">
            Export
          </Button> */}
        </div>
        {/* <SearchInput onChange={handleSearchChange} value={searchValue} /> */}
      </header>
      <section>
        {/* <div className="tab-section">
          <SwitchBox
            tabs={DetailSummaryList}
            settingsHandle={handleSettingsChange}
          />
          <div className="flex gap-5 items-center  mb-[15px]">
            <div className="detail_date_block">
              <h5>{formatSelectedWeek()}</h5>
              <div className="custom-calendar-wrapper">
                <DatePicker.WeekPicker onChange={handleWeekChange} />
              </div>
            </div>

          </div>
        </div> */}
        <div className="tab-body-section">
          <PaymentHistoryTable
            data={PaymentHistoryData}
            paymentHistory={paymentHistory}
            onPaginationChange={onPaginationChange}
          />
        </div>
      </section>
    </section>
  );
};

export default PaymentHistory;
